import { render, staticRenderFns } from "./SafetyLogin.vue?vue&type=template&id=04509add"
import script from "./SafetyLogin.vue?vue&type=script&lang=js"
export * from "./SafetyLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports